import React, { ReactNode, useEffect, useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useClickAway } from "react-use";
import { useHistory } from "react-router-dom";
import { NativeHtml } from "../../../../types/nativeHtml";

type SmoothDropdownProps = {
	children?: ReactNode;
	id: any;
	style?: NativeHtml["style"];
};
const SmoothDropdown: React.FC<SmoothDropdownProps> = ({
	children,
	id,
	style,
}) => {
	const [active, setActive] = useState(false);
	const ref = useRef<HTMLDivElement>(null);
	const history = useHistory();

	useEffect(() => {
		const cleanupListen = history.listen((event) => {
			if (active) {
				setActive(false);
			}
		});
		return () => {
			cleanupListen();
		};
	}, [active, history]);

	useClickAway(ref, (_event) => {
		if (active) {
			setActive(false);
		}
	});

	const parentProps = {
		ref,
		style,
	};

	return (
		<div {...parentProps} aria-hidden={active} aria-expanded={active}>
			<Dropdown
				id={id}
				open={active}
				onToggle={(_, __, currentTarget) => {
					if (currentTarget.source === "click") {
						setActive(!active);
					}

					if (currentTarget.source === "rootClose") {
						setActive(!active);
					}
				}}
				onSelect={() => {
					setActive(!active);
				}}
			>
				{children}
			</Dropdown>
		</div>
	);
};

export default SmoothDropdown;
